import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-spinner',
  imports: [ProgressSpinnerModule],
  template: `
    <p-progressSpinner
      data-testid="spinner"
      [style]="{ width: '56px', height: '56px' }"
      styleClass="custom-spinner"
      strokeWidth="2"
      animationDuration="1.5s"
    ></p-progressSpinner>
  `,
  styles: [
    `
      :host ::ng-deep .custom-spinner .p-progress-spinner-circle {
        animation:
          custom-progress-spinner-dash 1.5s ease-in-out infinite,
          custom-progress-spinner-color 6s ease-in-out infinite;
      }
      @keyframes custom-progress-spinner-color {
        100%,
        0% {
          stroke: darkred;
        }
        40%,
        66% {
          stroke: red;
        }
        80%,
        90% {
          stroke: darkred;
        }
      }

      @keyframes custom-progress-spinner-dash {
        0% {
          stroke-dasharray: 1, 200;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 89, 200;
          stroke-dashoffset: -35px;
        }
        100% {
          stroke-dasharray: 89, 200;
          stroke-dashoffset: -124px;
        }
      }
    `
  ],
  standalone: true
})
export class SpinnerComponent {}
